<template>
  <div class="side">
    <el-menu default-active="/" class="" router theme="dark">
      <el-menu-item index="/">弹幕查询</el-menu-item>
      <el-menu-item index="/statistics">月度弹幕统计</el-menu-item>
      <el-menu-item index="/statistics/day">每日弹幕统计</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
  export default {
    name: 'side',
    data () {
      return {

      }
    },
    created () {

    },
    watch: {

    },
    methods: {
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// side.vue?7e051500